import { Head } from "@shared/components/head";
import { Text } from "@shared/components/text";
import { useState } from "react";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { TouchableOpacity, View } from "react-native";
import Button from "@shared/components/md-design-system/Button/Button";
import { CustomRadio } from "@shared/components/md-design-system/Radio/CustomRadio";
import { TDrugSlot } from "app/_modules/core/types";
import { getElapsedSlots, getSlotRangeLabel } from "app/_modules/core/utils/drugIntake";
import { getServerNow } from "@shared/utils/serverClock";

const SLOTS: TDrugSlot[] = ['morning', 'afternoon', 'evening'];

export const DrugIntakeWindowSelectForm = ({ handleSubmit }: { handleSubmit: (slot: TDrugSlot) => void }) => {
    const { t } = dynamicTranslations();
    const [selectedSlot, setSelectedSlot] = useState<TDrugSlot | null>(null);
    const elapsedSlots = getElapsedSlots(getServerNow());

    return (
        <View className="flex-1 flex-col justify-between">
            <View className="flex-col gap-6">
                <Head type="h2">{t("drugs.windowSelect.question")}</Head>
                <Text className="text-gray-500">{t("drugs.windowSelect.subtitle")}</Text>
                <View className="flex-col gap-3">
                    {SLOTS.map((slot) => {
                        const isElapsed = elapsedSlots.includes(slot);
                        return (
                            <TouchableOpacity
                                key={slot}
                                disabled={!isElapsed}
                                className={`flex-row items-center justify-between gap-2 p-4 border rounded-lg ${isElapsed ? 'border-gray-300 bg-white' : 'border-gray-200 bg-gray-100'}`}
                                onPress={() => isElapsed && setSelectedSlot(slot)}
                            >
                                <View className="flex-col gap-1">
                                    <Text className={`font-semibold ${isElapsed ? '' : 'text-gray-400'}`}>
                                        {t(`drugs.windowSelect.slots.${slot}`)}
                                    </Text>
                                    <Text className={isElapsed ? 'text-gray-500' : 'text-gray-400'}>
                                        {getSlotRangeLabel(slot)}
                                    </Text>
                                </View>
                                <CustomRadio
                                    checked={selectedSlot === slot}
                                    disabled={!isElapsed}
                                    onChange={() => isElapsed && setSelectedSlot(slot)}
                                />
                            </TouchableOpacity>
                        );
                    })}
                </View>
            </View>

            <View className="mt-6">
                <Button onPress={() => selectedSlot && handleSubmit(selectedSlot)} disabled={!selectedSlot}>
                    {t("drugs.windowSelect.confirm")}
                </Button>
            </View>
        </View>
    );
};
